class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };

    /* measured by handleSticky(), read by onScroll() */
    this.extraSpace = 20;
    this.lastScroll = 0;
    this.resizeFrame = null;
    this.onScroll = this.onScroll.bind(this);

    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();

    /* Measure first, then bind the scroll listener EXACTLY once.
       handleSticky() used to add a fresh window scroll listener every time it
       ran, and it ran again on every matchMobile / unmatchMobile, so the
       listeners accumulated for the life of the page: cross the 1024px
       breakpoint five times and every scroll event ran six handlers. It is now
       measurement only, and the listener lives here. */
    this.handleSticky();
    window.addEventListener("scroll", this.onScroll, { passive: true });

    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());

    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;

    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      /* handleSticky() reads offsetHeight, which forces layout. Resize fires in
         bursts, so coalesce to one measurement per frame. */
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.handleSticky();
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  /* Measurement only. Safe to call as often as the layout changes. */
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    this.extraSpace = extraSpace;
    /* the desktop and mobile bars are different heights, so this has to be
       re-read when the breakpoint changes rather than kept from construction */
    if (this.domNodes && this.domNodes.headerWrapper) {
      this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    }
  }

  onScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll <= this.extraSpace) {
      this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
      document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
      this.lastScroll = currentScroll;
      return;
    }

    if (this.stickyHeader === "on_scroll_up") {
      this.classList.add(this.classes.stuck);
    } else if (this.stickyHeader === "always") {
      this.classList.add(this.classes.always);
    }

    if (
      currentScroll > this.headerHeight + this.extraSpace &&
      currentScroll > this.lastScroll &&
      !this.classList.contains(this.classes.scrollDown)
    ) {
      this.classList.remove(this.classes.scrollUp);
      document.body.classList.remove(this.classes.headerScrollUp);
      this.classList.add(this.classes.scrollDown);
      document.body.classList.add(this.classes.headerScrollDown);
    } else if (currentScroll < this.lastScroll && this.classList.contains(this.classes.scrollDown)) {
      this.classList.remove(this.classes.scrollDown);
      document.body.classList.remove(this.classes.headerScrollDown);
      this.classList.add(this.classes.scrollUp);
      document.body.classList.add(this.classes.headerScrollUp);
    }

    this.lastScroll = currentScroll;
  }
}
customElements.define("m-header", MHeader);
